export default __webpack_public_path__ + "a60f7f1395c604b64c059821a45751cd.svg";